import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';

export type TDropdownItem = {
  label: string;
  action: () => void;
  iconName?: string; // TODO: implement when Icon component is ready
  disabled?: boolean;
  className?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: TDropdownItem[];
};



const isOpen = ref(false);
const container = ref<HTMLElement | null>(null);
const menuRef = ref<HTMLElement | null>(null);
const menuStyle = ref<Record<string, string>>({});

function toggle() {
  isOpen.value = !isOpen.value;
}

function close() {
  isOpen.value = false;
}

function select(item: TDropdownItem) {
  if (item.disabled) return;

  item.action();
  close();
}

function updatePosition() {
  if (!container.value) return;
  const rect = container.value.getBoundingClientRect();
  menuStyle.value = {
    position: 'fixed',
    top: `${rect.bottom}px`,
    right: `${window.innerWidth - rect.right}px`,
    minWidth: `${rect.width}px`,
  };
}

function onClickOutside(e: MouseEvent) {
  const target = e.target as Node;
  if (!isOpen.value) return;
  if (container.value?.contains(target) || menuRef.value?.contains(target)) return;

  close();
}

watch(isOpen, (val) => {
  if (val) {
    updatePosition();
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
  } else {
    window.removeEventListener('scroll', close, true);
    window.removeEventListener('resize', close);
  }
});

onMounted(() => {
  document.addEventListener('mousedown', onClickOutside);
  if (menuRef.value) document.body.appendChild(menuRef.value);
});

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onClickOutside);
  window.removeEventListener('scroll', close, true);
  window.removeEventListener('resize', close);
  menuRef.value?.remove();
});

return { __sfc: true,props, isOpen, container, menuRef, menuStyle, toggle, close, select, updatePosition, onClickOutside }
}

})